import * as types from '@/store/types'
export default {
    addApp_v(context, payload) {
        context.app_vk.push(payload)
    },
    loadApp_vk(context, payload) {
        context.app_vk = payload
    },
    setApp_v: (context, payload) => {
        const index = context.app_vk.findIndex(item => item.id === payload.id)
        context.app_vk[index] = payload
    },
    changeBotIdModelDefault: (context, botId) => {
        context.modelDefault.bot_id = botId
    },
    getClientInfo: (context, payload) => {
        if (payload.type === 'GetClientInfoResult') {
            context.allowMessagesGroup = payload.response.allowed_messages
            context.allowMessagesGroupError = false
        } else if (payload.type === 'GetClientInfoFailed') {
            context.allowMessagesGroup = payload.response.allowed_messages
            context.allowMessagesGroupError = true
        }
        if (payload.response.hasOwnProperty('bot_id')) {
            context.botId = payload.response.bot_id
        }
    },
    setClient: (context, payload) => {
        // console.log(payload)
        context.client = payload
    },
    loadAllowMessagesGroupList: (context, payload) => {
        context.allowMessagesGroupList = payload
    },
    unsubscribeClient: (context, payload) => {
        const mailingGroupId = payload.success.data.mailing_group_id
        let index = context.allowMessagesGroupList.indexOf(mailingGroupId)
        if (index !== -1) {
            context.allowMessagesGroupList.splice(index, 1)
        }
    },
    subscribeClient: (context, payload) => {
        const mailingGroupId = payload.success.data.mailing_group_id
        context.allowMessagesGroupList.push(mailingGroupId)
    },
    writeSign: (context, sign) => {
        context.sign = sign
    },
    loadMailingGroups: (context, payload) => {
        context.mailingGroups = payload
        context.mailingGroupsLoaded = true
    },
    changeCountMailingGroup: (context, payload) => {
        const index = context.mailingGroups.findIndex(item => item.id === +payload.id)
        if (context.mailingGroups[index] !== undefined) {
            if (payload.subscribe === 1) {
                context.mailingGroups[index].count += payload.count
            } else {
                if (context.mailingGroups[index].count - payload.count >= 0) {
                    context.mailingGroups[index].count -= payload.count
                } else {
                    context.mailingGroups[index].count = 0
                }
            }
        }
    },
    changeAdminMode: (context, value) => {
        context.adminMode = value
    }
}
